import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=54cef73c"
import script from "./ContactsView.vue?vue&type=script&lang=js"
export * from "./ContactsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports